// extracted by mini-css-extract-plugin
var _1 = "RentalPortalMatchProvenanceLegend-moduleRentalPortalMatchProvenanceLegend__WDHD0";
var _2 = "RentalPortalMatchProvenanceLegend-moduletitle__XWxJo";
export { _1 as "RentalPortalMatchProvenanceLegend", _2 as "title" }
